export class LoadCicdFactorisationsData {
    static type = '[CICD] LoadCicdFactorisationsData'
    constructor(){}
}

export class SetCicdFactorisationMode {
    static type = '[CICD] SetCicdFactorisationMode'
    constructor(public payload: any){}
}

export class ClearCicdFactorisationsRepository {
    static type = '[CICD] ClearCicdFactorisationsRepository'
    constructor(){}
}

export class SetCicdFactorisationsRepository {
    static type = '[CICD] SetCicdFactorisationsRepository'
    constructor(public payload: any){}
}